import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import SriLanka from './pages/SriLanka';
import TourPackages from './pages/TourPackages';
import Excursions from './pages/Excursions';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';
import AyurvedaPage from './pages/AyurvedaPage';
import DivingPage from './pages/DivingPage';
import ElephantRidePage from './pages/ElephantRidePage';
import FishingPage from './pages/FishingPage';
import BallooningPage from './pages/BallooningPage';
import JeepSafariPage from './pages/JeepSafariPage';
import WhiteWaterRaftingPage from './pages/WhiteWaterRaftingPage';
import RiverSafariPage from './pages/RiverSafariPage';
import SnorkelingPage from './pages/SnorkelingPage';
import TeaTastingPage from './pages/TeaTastingPage';
import TempleVisitPage from './pages/TempleVisitPage';
import WildlifeSafariPage from './pages/WildlifeSafariPage';
import WhatsApp from './components/WhatsApp';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Travel with Ashan Beruwala Sri Lanka - Discover Sri Lanka"
                  description="Join Travel with Ashan Beruwala Sri Lanka to explore stunning landscapes, cultural heritage, and thrilling adventures. Book your dream vacation today!"
                  keywords="Travel with Ashan, Sri Lanka Tours, Travel Sri Lanka, Sri Lanka Vacation, Adventure Tours, Cultural Tours, Beruwala Tours, Sri Lanka Travel Deals"
                  url="https://www.ashantours.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Travel with Ashan Beruwala Sri Lanka"
                  description="Learn about Travel with Ashan Beruwala Sri Lanka, your trusted partner for exploring Sri Lanka’s rich culture, history, and natural beauty."
                  keywords="Travel with Ashan, About Travel with Ashan, Sri Lanka Travel, Beruwala Tours, Sri Lanka Tour Company"
                  url="https://www.ashantours.com/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Travel with Ashan Beruwala Sri Lanka"
                  description="Discover the beauty of Sri Lanka with Travel with Ashan Beruwala Sri Lanka, from pristine beaches to ancient temples and lush jungles."
                  keywords="Explore Sri Lanka, Travel with Ashan, Sri Lanka Travel, Cultural Tours, Sri Lanka Sightseeing, Beruwala Tours"
                  url="https://www.ashantours.com/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Travel with Ashan Beruwala Sri Lanka"
                  description="Find the perfect tour package with Travel with Ashan Beruwala Sri Lanka, offering customized adventures, cultural experiences, and more in Sri Lanka."
                  keywords="Sri Lanka Tour Packages, Travel with Ashan, Adventure Tours, Cultural Tours, Sri Lanka Vacation, Beruwala Tours"
                  url="https://www.ashantours.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/excursions"
            element={
              <>
                <SEO
                  title="Excursions - Travel with Ashan Beruwala Sri Lanka"
                  description="Experience exciting excursions with Travel with Ashan Beruwala Sri Lanka, exploring Sri Lanka’s hidden gems and iconic landmarks."
                  keywords="Sri Lanka Excursions, Travel with Ashan, Sri Lanka Sightseeing, Adventure Tours, Beruwala Tours"
                  url="https://www.ashantours.com/excursions"
                />
                <Excursions />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things To Do - Travel with Ashan Beruwala Sri Lanka"
                  description="Discover a variety of activities with Travel with Ashan Beruwala Sri Lanka, including wildlife safaris, cultural visits, and adventure sports in Sri Lanka."
                  keywords="Things To Do in Sri Lanka, Travel with Ashan, Adventure Activities, Cultural Experiences, Wildlife Tours, Beruwala Tours"
                  url="https://www.ashantours.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Travel with Ashan Beruwala Sri Lanka"
                  description="Book your Sri Lanka adventure with Travel with Ashan Beruwala Sri Lanka. Contact us to plan your perfect trip!"
                  keywords="Book Sri Lanka Tours, Travel with Ashan, Sri Lanka Vacation Booking, Beruwala Tours, Travel Planning"
                  url="https://www.ashantours.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Travel with Ashan Beruwala Sri Lanka"
                  description="Get in touch with Travel with Ashan Beruwala Sri Lanka for inquiries and bookings. Reach us at Beruwala, Sri Lanka, or via email and phone."
                  keywords="Contact Travel with Ashan, Sri Lanka Tour Contact, Beruwala Tours, Travel Inquiries, Travel with Ashan Contact"
                  url="https://www.ashantours.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />

          {/* Things To Do Individual Pages */}
          <Route
            path="/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda Experiences - Travel with Ashan Beruwala Sri Lanka"
                  description="Immerse yourself in authentic Ayurvedic experiences with Travel with Ashan Beruwala Sri Lanka, exploring Sri Lanka’s traditional wellness practices."
                  keywords="Ayurveda Sri Lanka, Travel with Ashan, Wellness Tours, Sri Lanka Cultural Experiences, Beruwala Tours"
                  url="https://www.ashantours.com/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/diving"
            element={
              <>
                <SEO
                  title="Diving in Sri Lanka - Travel with Ashan Beruwala Sri Lanka"
                  description="Dive into Sri Lanka’s vibrant underwater world with Travel with Ashan Beruwala Sri Lanka, offering thrilling diving adventures."
                  keywords="Diving Sri Lanka, Travel with Ashan, Adventure Tours, Underwater Activities, Beruwala Tours"
                  url="https://www.ashantours.com/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Rides - Travel with Ashan Beruwala Sri Lanka"
                  description="Experience unforgettable elephant rides with Travel with Ashan Beruwala Sri Lanka, connecting with Sri Lanka’s majestic wildlife."
                  keywords="Elephant Rides Sri Lanka, Travel with Ashan, Wildlife Tours, Adventure Activities, Beruwala Tours"
                  url="https://www.ashantours.com/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/fishing"
            element={
              <>
                <SEO
                  title="Fishing Adventures - Travel with Ashan Beruwala Sri Lanka"
                  description="Join Travel with Ashan Beruwala Sri Lanka for exciting fishing adventures in Sri Lanka’s pristine waters."
                  keywords="Fishing Sri Lanka, Travel with Ashan, Adventure Tours, Water Activities, Beruwala Tours"
                  url="https://www.ashantours.com/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Travel with Ashan Beruwala Sri Lanka"
                  description="Soar above Sri Lanka’s stunning landscapes with Travel with Ashan Beruwala Sri Lanka’s hot air ballooning experiences."
                  keywords="Hot Air Ballooning Sri Lanka, Travel with Ashan, Adventure Tours, Aerial Tours, Beruwala Tours"
                  url="https://www.ashantours.com/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safaris - Travel with Ashan Beruwala Sri Lanka"
                  description="Explore Sri Lanka’s wildlife with thrilling jeep safaris organized by Travel with Ashan Beruwala Sri Lanka."
                  keywords="Jeep Safari Sri Lanka, Travel with Ashan, Wildlife Tours, Adventure Tours, Beruwala Tours"
                  url="https://www.ashantours.com/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Travel with Ashan Beruwala Sri Lanka"
                  description="Experience the thrill of white water rafting in Sri Lanka with Travel with Ashan Beruwala Sri Lanka, navigating the Kelani River’s rapids."
                  keywords="White Water Rafting Sri Lanka, Travel with Ashan, Adventure Tours, Kelani River Rafting, Beruwala Tours"
                  url="https://www.ashantours.com/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/river-safari"
            element={
              <>
                <SEO
                  title="River Safaris - Travel with Ashan Beruwala Sri Lanka"
                  description="Discover Sri Lanka’s serene rivers with Travel with Ashan Beruwala Sri Lanka’s river safari adventures."
                  keywords="River Safari Sri Lanka, Travel with Ashan, Nature Tours, Adventure Activities, Beruwala Tours"
                  url="https://www.ashantours.com/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling in Sri Lanka - Travel with Ashan Beruwala Sri Lanka"
                  description="Explore vibrant coral reefs with Travel with Ashan Beruwala Sri Lanka’s snorkeling adventures in Sri Lanka’s clear waters."
                  keywords="Snorkeling Sri Lanka, Travel with Ashan, Adventure Tours, Marine Activities, Beruwala Tours"
                  url="https://www.ashantours.com/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/tea-tasting"
            element={
              <>
                <SEO
                  title="Tea Tasting - Travel with Ashan Beruwala Sri Lanka"
                  description="Savor Sri Lanka’s world-famous Ceylon tea with Travel with Ashan Beruwala Sri Lanka’s tea tasting experiences."
                  keywords="Tea Tasting Sri Lanka, Travel with Ashan, Cultural Tours, Ceylon Tea, Beruwala Tours"
                  url="https://www.ashantours.com/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Travel with Ashan Beruwala Sri Lanka"
                  description="Explore Sri Lanka’s sacred temples with Travel with Ashan Beruwala Sri Lanka, immersing in rich cultural heritage."
                  keywords="Temple Visits Sri Lanka, Travel with Ashan, Cultural Tours, Sri Lanka Heritage, Beruwala Tours"
                  url="https://www.ashantours.com/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safaris - Travel with Ashan Beruwala Sri Lanka"
                  description="Join Travel with Ashan Beruwala Sri Lanka for thrilling wildlife safaris in Sri Lanka’s national parks, spotting elephants, leopards, and more."
                  keywords="Wildlife Safari Sri Lanka, Travel with Ashan, Wildlife Tours, National Parks Sri Lanka, Beruwala Tours"
                  url="https://www.ashantours.com/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />
        </Routes>
      </main>
      <WhatsApp />
      <Footer />
    </Router>
  );
};

export default App;